import { createModuleActionCreators } from "src/utils";
import { NAME } from "./constants";

const { createPayloadAction } = createModuleActionCreators(NAME);

/**
 * save access token into redux, RTK will use it in every request
 */
export const setAccessToken = createPayloadAction("SET_ACCESS_TOKEN")<string>();
